<script setup>
    import {ref} from 'vue'

    import {
        StarIcon,
        PlusIcon
    } from '@heroicons/vue/outline'

    const props = defineProps({
        item: {
            type: Object,
            required: true
        },
    })

    const isActive = ref(route().current(props.item.routeName));

</script>
<template>
    <li
        class="relative translate-x-px pl-2"
    >
        <div
            v-if="isActive"
            class="rounded-wl bg-brandPrimary-500 absolute left-2 top-1 bottom-1 z-40"
            style="width: 3px; margin-left: 2px;"
        ></div>
        <a
            :href="item.href"
            class="relative z-30 block py-1 text-xs hover:underline border-l pl-2 translate-x-px font-light tracking-tight"
            style="margin-left: 2px;"
            :class="isActive ? 'text-brandPrimary-500' : ''"
        >
            {{ _mft(item.name) }}
        </a>
    </li>
</template>
